import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

// Self-loop on a single node (like MaxGraph loop style).
export default function LoopEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
  isHovered,
  onHoverEnter,
  onHoverLeave,
}) {
  const node = nodeById[edge.from];
  if (!node) return null;

  // Loop positioned on right side by default
  const x = roundTo(node.x + node.width);
  const y = roundTo(node.y + node.height / 2);

  const rX = 40; // horizontal radius of the loop
  const rY = 24; // vertical radius

  // Simple closed cubic curve forming a loop
  const d = `M ${x} ${y}
             C ${x + rX} ${y - rY},
               ${x + rX} ${y + rY},
               ${x} ${y}`;

  const labelPos = {
    x: x + rX,
    y: y - rY - 8,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      // NEW HOVER SUPPORT
      isHovered={isHovered}
      onHoverEnter={onHoverEnter}
      onHoverLeave={onHoverLeave}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
